export default {
  controls: []
}
